export default {
  controls: []
}
